import UtilityCountry from "../domain/Util/UtilityCountry";
import UtilityProvince from "../domain/Util/UtilityProvince";
import WsService from "./WsService";

const ENDPOINT_BASE = "/utility";

export default class UtilityService {

    static retrieveCountryList() {

        let endpoint = ENDPOINT_BASE + "/country";

        return WsService.get(endpoint, {}, 200).then(
            response => {
                let countryResults = [];
                response.forEach(singleCountry => {
                    countryResults.push(new UtilityCountry(singleCountry));
                });

                return countryResults;
            },
            response => {
                return response;
            });
    }

    static retrieveProvinceList() {

        let endpoint = ENDPOINT_BASE + "/province";

        return WsService.get(endpoint, {}, 200).then(
            response => {

                let results = [];

                response.forEach(province => {
                    results.push(new UtilityProvince(province))
                });

                return results;

            },
            response => {

                return response;

            }
        )

    }

}